import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("contractBackupDatabase.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, id, request) {
  return axios.put(
    api.path("contractBackupDatabase.update", {
      contractId: contractId,
      id: id
    }),
    request
  );
}

export function list(contractId) {
  return axios.get(
    api.path("contractBackupDatabase.index", { contractId: contractId })
  );
}

export function show(contractId, id) {
  return axios.get(
    api.path("contractBackupDatabase.show", {
      contractId: contractId,
      id: id
    })
  );
}

export function remove(contractId, id) {
  return axios.delete(
    api.path("contractBackupDatabase.remove", {
      contractId: contractId,
      id: id
    })
  );
}

export function download(contractId, id) {
  return axios.get(
    api.path("contractBackupDatabase.download", {
      contractId: contractId,
      id: id
    })
  );
}
